import { Category, Product, StoreDetailData } from "./types";

export const storesDetails: { [key: string]: StoreDetailData } = {
  // Use the REAL _id from your API as the key AND in the object
  "67f458c08ad57c0167c6828a": {
    _id: "67f458c08ad57c0167c6828a", // Real ID
    name: "Main Warehouse", // Corresponds to storeName
    address: "1 Warehouse Way", // Add address if needed by StoreDetail
    location: "Los Angeles, CA",
    code: "WH-LA-01", // Add code if needed
    phone: "555-1234", // Corresponds to contactInfo
  },
  "67f45d0a8ad57c0167c6902c": {
    _id: "67f45d0a8ad57c0167c6902c", // Another Real ID
    name: "Secondary Warehouse",
    address: "2 Logistics Ave",
    location: "San Diego, CA",
    code: "WH-SD-01",
    phone: "555-5678",
  },
  "67f4ec6b60a53b5bbf55c7f4": {
    _id: "67f4ec6b60a53b5bbf55c7f4", // Another Real ID
    name: "Tertiary Warehouse",
    address: "3 Distribution St",
    location: "New York, NY",
    code: "WH-SD-01",
    phone: "555-5678",
  },
  "67f4ecb760a53b5bbf55cb92": {
    _id: "67f4ecb760a53b5bbf55cb92", // Another Real ID
    name: "Tertiary Warehouse1",
    address: "4 Distribution St",
    location: "New York, NY",
    code: "WH-SD-01",
    phone: "555-5678",
  },
  // Add other stores with their REAL IDs
};

export const fetchProductsByStore = (storeId: string): Promise<Product[]> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      // Now looks up using the real storeId key
      resolve(products[storeId] || []);
    }, 300); // Reduced timeout slightly
  });
};

export const fetchStoreById = (
  storeId: string
): Promise<StoreDetailData | null> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      // Look up directly using the real storeId key
      const store = storesDetails[storeId];
      resolve(store || null);
    }, 300); // Reduced timeout slightly
  });
};

// Dummy data for products
export const products: { [key: string]: Product[] } = {
  "67f458c08ad57c0167c6828a": [
    {
      id: "67f458c08ad57c0167c6828a",
      name: "Tomatoes",
      category: "Vegetable",
      price: 690.0,
      quantity: 63,
      image: "/products/tomatoes.jpg",
      attribute: "Top Selling",
    },
    {
      id: "2",
      name: "Orange",
      category: "Fruits",
      price: 190.0,
      quantity: 13,
      image: "/products/orange.jpg",
      attribute: "Selling",
    },
    {
      id: "3",
      name: "Rice",
      category: "Grain",
      price: 640.0,
      quantity: 635,
      image: "/products/rice.jpg",
      attribute: "Regular",
    },
    {
      id: "4",
      name: "Zobo",
      category: "Drinks",
      price: 400.0,
      quantity: 67,
      image: "/products/zobo.jpg",
      attribute: "Top Selling",
    },
    {
      id: "5",
      name: "Potatoes",
      category: "Dietary",
      price: 420.0,
      quantity: 52,
      image: "/products/potatoes.jpg",
      attribute: "Regular",
    },
    {
      id: "6",
      name: "Beef",
      category: "Meat",
      price: 190.0,
      quantity: 13,
      image: "/products/beef.jpg",
      attribute: "Selling",
    },
  ],
  "67f45d0a8ad57c0167c6902c": [
    {
      id: "1",
      name: "Chicken",
      category: "Meat",
      price: 1200.0,
      quantity: 45,
      image: "/products/chicken.jpg",
      attribute: "Top Selling",
    },
    {
      id: "2",
      name: "Apples",
      category: "Fruits",
      price: 250.0,
      quantity: 30,
      image: "/products/apples.jpg",
      attribute: "Selling",
    },
  ],
};

// Dummy data for categories
export const categories: Category[] = [
  {
    id: "1",
    name: "Frozen Foods",
    description:
      "Frozen food items including vegetables, meat, and ready meals",
    image: "/categories/frozen-foods.jpg",
  },
  {
    id: "2",
    name: "Fresh Produce",
    description: "Fresh fruits and vegetables",
    image: "/categories/fresh-produce.jpg",
  },
  {
    id: "3",
    name: "Dairy",
    description: "Milk, cheese, and other dairy products",
    image: "/categories/dairy.jpg",
  },
  {
    id: "4",
    name: "Bakery",
    description: "Bread, cakes, and pastries",
    image: "/categories/bakery.jpg",
  },
  {
    id: "5",
    name: "Beverages",
    description: "Drinks including water, juice, and soda",
    image: "/categories/beverages.jpg",
  },
  {
    id: "6",
    name: "Canned Goods",
    description: "Canned fruits, vegetables, and soups",
    image: "/categories/canned-goods.jpg",
  },
];

export const fetchCategories = (): Promise<Category[]> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(categories);
    }, 500);
  });
};

export const addProduct = (
  storeId: string,
  product: Omit<Product, "id">
): Promise<Product> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const newProduct = {
        id: Math.random().toString(36).substr(2, 9),
        ...product,
      };

      if (!products[storeId]) {
        products[storeId] = [];
      }

      products[storeId].push(newProduct);
      resolve(newProduct);
    }, 500);
  });
};

export const updateProduct = (
  storeId: string,
  product: Product
): Promise<Product> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      if (products[storeId]) {
        const index = products[storeId].findIndex((p) => p.id === product.id);
        if (index !== -1) {
          products[storeId][index] = product;
          resolve(product);
        }
      }
      resolve(product);
    }, 500);
  });
};

export const deleteProduct = (
  storeId: string,
  productId: string
): Promise<{ success: boolean }> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      if (products[storeId]) {
        const index = products[storeId].findIndex((p) => p.id === productId);
        if (index !== -1) {
          products[storeId].splice(index, 1);
          resolve({ success: true });
        }
      }
      resolve({ success: false });
    }, 500);
  });
};

export const addCategory = (
  category: Omit<Category, "id">
): Promise<Category> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const newCategory = {
        id: Math.random().toString(36).substr(2, 9),
        ...category,
      };

      categories.push(newCategory);
      resolve(newCategory);
    }, 500);
  });
};
